import { http } from './http'
import { Pagination, PaginationParams } from './map'

export type StaffPermission = 'CHECKIN' | 'CHECKOUT'

export interface Staff {
  id: string
  name: string
  phone: string
  permissions: StaffPermission[]
}

export const getStaff = (
  params?: PaginationParams & { name?: string; phone?: string },
) => http.get<Pagination<Staff>>('/operations/staff', { params })

export const singleStaff = (id: string) =>
  http.get<Staff>(`/operations/staff/${id}`)

export const createStaff = (data: Partial<Staff>) =>
  http.post<Staff>('/operations/staff', data)

export const updateStaff = (id: string, data: Partial<Staff>) =>
  http.put<Staff>(`/operations/staff/${id}`, data)

export const deleteStaff = (id: string) =>
  http.delete<void>(`/operations/staff/${id}`)
